import { useParams } from "react-router";
import { DaEmailLinkExpired } from "../../components/DaEmailLinkExpired/DaEmailLinkExpired";

function DaEmailLinkExpiredPage() {
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;
  return (
    <div className={theme} data-testid="theme-name">
      {tenant === "ms1" ? <DaEmailLinkExpired /> : null}
    </div>
  );
}

export default DaEmailLinkExpiredPage;
